<template>
    <div class="quest-page">
    <h2>Квесты</h2>
      <ExperimentCard
      title="Квест по физике"
      description="Интерактивный квест по физике с задачами и экспериментами."
      link="/квест-по-физике"
    />
    <ExperimentCard
      title="Квест по информатике"
      description="Интерактивный квест по информатике с задачами и экспериментами."
      link="/квест-по-информатике"
    />

    <ExperimentCard
      title="QR-квест"
      description="Квест с использованием QR-кодов для поиска информации и выполнения заданий."
      link="/qr-квест"
    />
    
    <ExperimentCard
      title="Квест по педагогике"
      description="Интерактивный квест по педагогике с задачами и экспериментами."
      link="/квест-по-педагогике"
    />

  </div>
</template>


<script>
import ExperimentCard from "@/components/ExperimentCard.vue";

export default {
  components: {
    ExperimentCard,
  }
};
</script>

<style scoped>
.quest-page {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 20px;
}
</style>